import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Number from './number';

import * as S from './styles';

export default class Numbers extends Component {
  constructor(props) {
    super(props);
    this.numberRefs = [];
    this.wrapper = null;
  }

  componentDidMount() {
    this.adjustVisibleNumbers();
  }

  getSectionValues() {
    return this.props.sections.reduce((values, section, index) => {
      const fillData = this.props.getSectionFillData(index);
      if (index === 0) {
        values.push({
          value: section.from,
          index,
          selected: fillData.from,
        });
      }
      values.push({
        value: section.to,
        index: index + 1,
        selected: fillData.to,
      });
      return values;
    }, []);
  }

  /* eslint-disable no-plusplus, react/no-find-dom-node, no-continue, no-constant-condition */
  adjustVisibleNumbers() {
    if (!this.wrapper) {
      return;
    }
    let lastVisibleNode = null;
    const selector = 'button';

    const length = this.getSectionValues().length;
    if (true || !this.visibleNumbersAdjusted) {
      for (let i = 0; i < length; i++) {
        const numberNode = ReactDOM.findDOMNode(this.numberRefs[`number${i}`]);

        if (!numberNode) {
          continue;
        }

        let currentNode = numberNode.querySelector(`${selector}`);
        if (!currentNode) {
          continue;
        }
        currentNode.style.display = 'block';

        if (lastVisibleNode === null) {
          lastVisibleNode = numberNode.querySelector(`${selector}`);
          continue;
        }

        const lastVisibleRect = lastVisibleNode.getBoundingClientRect();
        const currentRect = currentNode.getBoundingClientRect();
        const distance = currentRect.left - lastVisibleRect.right;

        // we need some distance between the numbers,
        // i.e we do not want to show number too close to each other like 2030, we want 20 30.
        if (distance < 5) {
          // numbers are overlapping, hide current node UNLESS current node is the last node.
          // Because we do want to show the edge numbers they are more important than the others.
          if (i === length - 1) {
            currentNode = lastVisibleNode;
          }
          currentNode.style.display = 'none';
        } else {
          lastVisibleNode = currentNode;
        }
      }
      this.visibleNumbersAdjusted = true;
    }
  }

  renderNumber(section, index) {
    return (
      <Number
        key={`number${index}`}
        layout={this.props.layout}
        ref={c => {
          this.numberRefs[`number${index}`] = c;
        }}
        value={section.value}
        index={section.index}
        onChange={this.props.onChange}
        {...section}
      />
    );
  }

  render() {
    const sectionValues = this.getSectionValues();
    return (
      <S.NumberWrapper
        ref={node => {
          this.wrapper = node;
        }}
      >
        {sectionValues.map(this.renderNumber, this)}
      </S.NumberWrapper>
    );
  }
}

Numbers.propTypes = {
  layout: PropTypes.oneOf(['vertical', 'horizontal']).isRequired,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      from: PropTypes.number,
      to: PropTypes.number,
      products: PropTypes.number,
    })
  ).isRequired,
  getSectionFillData: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};
